module.exports = __webpack_public_path__ + "img/alarme_de_seguranca.280e8c75.svg";